import React, { Component } from "react";
import { Link } from "react-router";
import { Helmet } from "react-helmet";

import "./assets/style.scss";

import Client1 from "./assets/clients/ace.png";
import Client2 from "./assets/clients/goodlive.svg";
import Client3 from "./assets/clients/bunker.png";
import Client4 from "./assets/clients/dlp.png";
import Client5 from "./assets/clients/selective.png";
import Client6 from "./assets/clients/luckyent.png";

import Intro from "./assets/intro.png";
import Dashboard from "./assets/dashboard.png";
import Team from "./assets/team.png";
import Finance from "./assets/finance.png";
import Calendar from "./assets/calendar.png";
import Service from "./assets/service.png";
import Advancing from "./assets/advancing.png";
import BirdsEye from "./assets/birdseye.png";
import Collab from "./assets/collab.png";

export default class Agency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuActive: false,
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const element = document.getElementsByClassName(
      "aboss__agency-base-content"
    );
    if (element[0].getBoundingClientRect().top - 25 < 0) {
      this.setState({ menuActive: true });
    } else {
      this.setState({ menuActive: false });
    }
  };

  render() {
    return (
      <div className="aboss__agency">
        <Helmet>
          <title>
            ABOSS Agency - Manage multiple calendars, structure your back office
            and gain insight in data to optimize business strategies
          </title>
          <meta
            name="description"
            content="ABOSS Agency - manage multiple calendars, structure your back office and gain insight in data to optimize business strategies"
          />
        </Helmet>
        <div className="aboss__agency-intro">
          <div className="aboss__agency-intro-content">
            <h1>Agency</h1>
            <h2>
              Manage multiple calendars, structure your back office and gain
              insight in data to optimize business strategies
            </h2>
            <div className="aboss__agency-intro-content-actions">
              <Link to="/sign-up#agency">
                <button className="yellow">Sign Up</button>
              </Link>
            </div>
            <div className="aboss__agency-intro-content-image">
              <img src={Intro} />
            </div>
          </div>
          <div className="aboss__agency-intro-references">
            <div className="aboss__agency-intro-references-content">
              <h1>You'll be in good company</h1>
              <p>
                Trusted and loved by hundreds of agencies from all over the
                globe representing world’s most promising artists.
              </p>
            </div>
            <div className="aboss__agency-intro-references-clients">
              <div className="aboss__agency-intro-references-clients-row">
                <div>
                  <a href="http://davidlewis.nl/" target="_client">
                    <img src={Client4} />
                  </a>
                </div>
                <div>
                  <a href="https://goodliveartists.com/" target="_client">
                    <img src={Client2} />
                  </a>
                </div>
                <div>
                  <a href="http://www.aceagency.com/" target="_client">
                    <img src={Client1} />
                  </a>
                </div>
              </div>
              <div className="aboss__agency-intro-references-clients-row">
                <div>
                  <a href="https://bunkertheaterzaken.nl/" target="_client">
                    <img src={Client3} />
                  </a>
                </div>
                <div>
                  <a href="https://selectiveartists.com/" target="_client">
                    <img src={Client5} />
                  </a>
                </div>
                <div>
                  <a href="http://www.luckyent.com/" target="_client">
                    <img src={Client6} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="aboss__agency-base">
          <div
            className={`aboss__agency-base-menu ${
              this.state.menuActive ? "active" : ""
            }`}
          >
            <ul>
              <li>
                <a href="#team-management">
                  •<span>Team Management</span>
                </a>
              </li>
              <li>
                <a href="#finance">
                  •<span>Finance & reporting</span>
                </a>
              </li>
              <li>
                <a href="#calendar">
                  •<span>Managing calendars</span>
                </a>
              </li>
              <li>
                <a href="#service">
                  •<span>Service to your artists</span>
                </a>
              </li>
              <li>
                <a href="#preproduction">
                  •<span>Production & logistics</span>
                </a>
              </li>
              <li>
                <a href="#birdeye">
                  •<span>Birds Eye view</span>
                </a>
              </li>
              <li>
                <a href="#collaboration">
                  •<span>Collaboration</span>
                </a>
              </li>
              <li>
                <a href="#support">
                  •<span>Support</span>
                </a>
              </li>
            </ul>
          </div>
          <div className="aboss__agency-base-content">
            <div
              className="aboss__agency-base-content-block"
              id="team-management"
            >
              <h1>Team Management</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Team} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Everything in one place</strong>
                      Have all the information in one single system and assign
                      each team member to their own selection of artists.
                    </li>
                    <li>
                      <strong>Unlimited users</strong>
                      Invite as many users as you need without any additional
                      costs. For team members within your agency to view/edit
                      information. And for your artists and their team to view
                      the artist calendar.
                    </li>
                    <li>
                      <strong>Access on a need-to-know basis</strong>
                      Assign specific permissions to each team member and grand
                      access to the agency back office on different levels.
                    </li>
                    <li>
                      <strong>Work remote</strong>
                      Access the system from anywhere in the world without any
                      limitations.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="aboss__agency-base-content-block" id="finance">
              <h1>Finance & reporting</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Finance} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Deals</strong>
                      Create your own deal for each event and have your artist
                      statement automatically calculated based on the actual
                      ticket sales.
                    </li>
                    <li>
                      <strong>Contracts</strong>Generate your personal branded
                      contract templates and track the status of each contract
                      in the overview section.
                    </li>
                    <li>
                      <strong>Invoices</strong>Create your branded templates for
                      show-related and non show-related invoices and run
                      multiple administrations for multiple companies and/or
                      artists within your Agency account.
                    </li>
                    <li>
                      <strong>Statements</strong>
                      Generate an overview of revenue and costs for each
                      individual artist in a specific period of time and export
                      to excel or pdf at any time within a few seconds.
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="aboss__agency-base-content-block" id="calendar">
              <h1>Managing calendars</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Calendar} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Manage multiple calendars</strong>
                      Have all your artist calendars in 1 central place and
                      assign your team members to specific calendars with
                      view/edit permissions for each artist. Each calendar can
                      be connected to the artist personal Google or iCal
                      calendar.
                    </li>
                    <li>
                      <strong>Add travel items</strong>
                      Organise flights, hotels and ground transportation in the
                      artists calendars for a full and up to date travel
                      itinerary. We also offer free integrations with Holcar
                      Travel and Munckhof.
                    </li>
                    <li>
                      <strong>Connect to Google calendar & iCal</strong>
                      All your calendars can be individually connected with your
                      prefered calendar software so your artists will receive
                      all the information realtime in their personal calendar.
                    </li>
                    <li>
                      <strong>Schedule the publication of tour dates</strong>
                      Publish shows with a single click or schedule your publish
                      date and time to update the connected websites and social
                      platforms automatically.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="aboss__agency-base-content-block" id="service">
              <h1>Service to your artists</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Service} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Free ABOSS Artist access</strong>
                      Give your artists free access to their own ABOSS Artist
                      account with view permissions and let them add blocks to
                      the calendar. Setup detailed sharing when the Artist has
                      their own paid artist account.
                    </li>
                    <li>
                      <strong>Invoice on behalf of the artist</strong>
                      Create invoice templates for your artists to invoice on
                      behalf of the artist company, so money can be transferred
                      straight into their own account.
                    </li>
                    <li>
                      <strong>Free mobile app</strong>
                      Inform your artists and their team with most recent dates
                      and information in their pocket. The mobile app is also
                      offline available to view information without an internet
                      connection.
                    </li>
                    <li>
                      <strong>
                        Connect tour dates with the website, Facebook &
                        bandsintown.
                      </strong>
                      Connect the artist calendar to the artists website through
                      our API or let us connect to your social platforms to
                      update their fans automatically of upcoming tour dates.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="aboss__agency-base-content-block"
              id="preproduction"
            >
              <h1>Production & logistics</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Advancing} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Advance events and share realtime</strong>
                      Add productional, technical and logistical information to
                      ABOSS and have this information directly available for the
                      artist and crew. You can always send out the automatically
                      generated PDF directly from the system.
                    </li>
                    <li>
                      <strong>Request info from third parties</strong>
                      Bored of all the copy and paste actions from email?
                      Request the information online so everyone only has to
                      enter the data once instead of multiple times on multiple
                      places.
                    </li>
                    <li>
                      <strong>Manage your location database</strong>
                      Build your location database to have standard info of
                      venues pushed into the advancing area automatically when
                      selecting a specific venue for an event. Our Google maps
                      integration makes it easy to find locations that are not
                      available in your database yet.
                    </li>
                    <li>
                      <strong>Production status dashboard</strong>A single
                      overview of completed and pending items on productional,
                      technical and logistical information.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="aboss__agency-base-content-block" id="birdeye">
              <h1>Birds Eye view</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={BirdsEye} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Dashboard</strong>Total overview of all shows with
                      all data. Create your own personal viewing templates with
                      specific datasets. Export to excel or pdf to share
                      specific (financial) information with the team or the
                      artist.
                    </li>
                    <li>
                      <strong>Create custom tags for smart reporting</strong>
                      Create labels and assign a specific color to each label to
                      optimise your overview and generate detailed financial
                      reporting whenever needed.
                    </li>
                    <li>
                      <strong>Statistics</strong>Learn from your data and
                      generate insights for your artists and the agents within
                      your company. With a few clicks you can view the average
                      fees for each specific agent, insights in the growth of
                      each artist, the revenue per month, revenue for each
                      country and more.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div
              className="aboss__agency-base-content-block"
              id="collaboration"
            >
              <h1>Collaboration</h1>
              <div className="aboss__agency-base-content-block-list">
                <div className="aboss__agency-base-content-block-list-image">
                  <img src={Collab} />
                </div>
                <div className="aboss__agency-base-content-block-list-content">
                  <ul>
                    <li>
                      <strong>Tasks & reminders</strong>
                      Setup your personal tasks and reminders in the Agency
                      calendar and connect the reminders to your iCal or Google
                      calendar to receive alerts from your device for those
                      tasks.
                    </li>
                    <li>
                      <strong>Connect with other Agency accounts</strong>Connect
                      with other Agency accounts from other territories to share
                      available dates, contacts & collaborate on shows for
                      deals, ticket sales and production.
                    </li>
                    <li>
                      <strong>Connect with (paid) Artist accounts</strong>
                      Connect with one or multiple paid Artist accounts to share
                      deals, contracts and statements realtime within the system
                      & collaborate on shows for availability, crew planning,
                      production and ticket sales.
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="aboss__agency-base-content-blocks">
              <h1>Start today</h1>
              <Link to="/sign-up#agency">
                <button className="yellow">Sign Up</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/views/products/agency/index.js